import { defineProvider } from '@nuxt/image/runtime';

// https://shopify.dev/docs/api/liquid/filters/img_url#img_url-size
export default defineProvider({
    getImage(src, { modifiers }) {
        let sizeModifier = '';
        if (modifiers.width) sizeModifier = `${modifiers.width}`;
        const aspectModifiers = getAssetAspectModifiers(modifiers);
        if (aspectModifiers.height) sizeModifier += `x${aspectModifiers.height}`;
        else if (modifiers.height) sizeModifier += `x${modifiers.height}`;
        // if only width is modified, we need to add 'x'
        else sizeModifier += sizeModifier.length ? 'x' : '';

        if (sizeModifier) sizeModifier = `_${sizeModifier}`;

        const url = src.replace('.jpg?', `${sizeModifier}.jpg?`).replace('.png?', `${sizeModifier}.png?`);
        return {
            url,
        };
    },
});
